import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { WindowEvent, WindowActionTypes, WindowTypes } from "./window.event";
import { WindowCreateRequest } from "./window.create.request";
import { WindowSettings } from "./window.settings";
import { WindowContext } from "./window.context";
import { UserRolesService } from "../user.roles.service";
import { GlobalService } from "../global.service";
import { ssApiService } from "../ss-api.service";
import { Router } from "@angular/router";

@Injectable()
export class WindowService {

    // default urls
    //private baseURL : string = "http://localhost:4200/dialog-window/"
    private baseURL : string = "/dialog-window/";
    //private baseURL : string = "http"
    private licenseURL : string = "/dialog-window/license";
    private memberURL : string = "/dialog-window/member";

    private emailURL : string = "/dialog-window/email";
    private ticketURL : string = "/dialog-window/ticket";
    private noteURL : string = "/dialog-window/note";

    private ticketAddURL : string= "/dialog-window/ticket-add";



    public ActiveWindows = new Array<WindowCreateRequest<any>>();

    public onLog = new Subject<string>();
    public onEvent = new Subject<WindowEvent>();
    public onNewWindow = new Subject<WindowCreateRequest<any>>();

    public onNavigate = new Subject<any>();

    public Log(strLog: string) {
        console.log("log:", strLog);
        this.onLog.next(strLog);
    }


    constructor(private gb: GlobalService, private userRolesService: UserRolesService, private api : ssApiService, private router : Router) {

        // add local storage event listener to intercept messages
        window.addEventListener('storage', (ev: StorageEvent) => {
            this.ProcessEvent(ev.key, ev.newValue);
        })

        this.licenseURL = this.baseURL + "license";
        this.memberURL = this.baseURL + "member";
    }

    private ProcessEvent(key: string, data: string) {

        // check if storage changes were window dialog events
        if (!key.startsWith("dialog.window.event."))
            // not a window event    
            return;

        if (data == undefined)
            return;

        // deserialize object
        let event: WindowEvent = JSON.parse(data);

        if (event == undefined)
            return;

        // submit event globally
        this.onEvent.next(event);

        // submit event on the window
        let activeWindow = this.ActiveWindows.find(x => x.ID == event.ID);
        if (activeWindow != undefined)
            activeWindow.onEvent.next(event);

        // remove from list if it is a close event
        if (event.ActionType == WindowActionTypes.Close)
            this.RemoveWindowByID(event.ID);

        // delete from storage
        localStorage.removeItem(key);
    }

    private RemoveWindowByID(id: string) {

        // search
        var index = this.ActiveWindows.findIndex(x => x.ID == id);
        if (index == -1)
            return;

        //remove
        this.ActiveWindows.splice(index);
    }

    public InvokeEvent(event: WindowEvent) {
    }

    public OpenWindow<InitDataType>(windowType: WindowTypes, initData: InitDataType, windowSettings: WindowSettings = undefined): WindowCreateRequest<InitDataType> {

        if (windowSettings == undefined)
            windowSettings = new WindowSettings();

        // create the window
        let newWindow = new WindowCreateRequest<InitDataType>();
        newWindow.WindowType = windowType;
        newWindow.InitData = initData;
        
        console.log("WindowTypetoUrl result:", this.WindowTypeToUrl(windowType));
        console.log("WindowSettings:", windowSettings.ToString());

        newWindow.WindowRef = window.open(this.WindowTypeToUrl(windowType), '', windowSettings.ToString());

        console.log("newWindow:", newWindow);

        // add functions to the window
        this.CreateWindowFunctions<InitDataType>(newWindow);

        // subscription
        newWindow.onEvent.subscribe( result => {
            this.HandleWindowEvent(result);
        });

        // add window to list
        this.ActiveWindows.push(newWindow);
        
        
        return newWindow;
    }

    private CreateWindowFunctions<T>(createRequest: WindowCreateRequest<T>) {

        let that = this;
        let window = (<any>createRequest.WindowRef);
        let context = this.CreateWindowContext<T>(createRequest);

        // this function will inject the context into the window object
        window.GetContext = function (): WindowContext<T> {
            return context;
        }

        // this functions is to indicate that the window finished loading
        // we invoke the Init function on the same window after ready
        window.SetReady = function () {
            // we can fire a ready event here
        };



    }

    private CreateWindowContext<T>(createRequest: WindowCreateRequest<T>): WindowContext<T> {

        let context = new WindowContext<T>();
        context.Data = createRequest.InitData;
        context.ID = createRequest.ID;
        context.UserRolesService = this.userRolesService;
        context.GlobalService = this.gb;
        context.WindowType = createRequest.WindowType;

        return context;
    }

    private WindowTypeToUrl(windowType: WindowTypes): string {
        switch (windowType) {
            case WindowTypes.License:
                return this.licenseURL;
            case WindowTypes.EditMember:
                return this.memberURL;
            case WindowTypes.Ticket:
                return this.ticketURL;
            case WindowTypes.Email:
                return this.emailURL;
            case WindowTypes.Note:
                return this.noteURL;
            case WindowTypes.TicketAdd:
                return this.ticketAddURL;

            default:
                return this.licenseURL;
        }
    }


    private HandleWindowEvent( event : WindowEvent) {
        switch(event.ActionType) {
            case WindowActionTypes.NavigateToMember:
                let memberURL = '/member-profile/' + event.Data.toString();
                this.router.navigate([ memberURL ]);
                this.onNavigate.next(true);
                break;
            
            default:
                break;
        }
    }

}